<div class="alert alert-{{this.type}} col-md-10 col-sm-10 col-xs-10 offset-md-1 offset-sm-1 offset-xs-1 animated fadeInDown" *ngIf="show">
{{message}}
</div>